import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ChangelogSchema } from './changelog';

/**
 * Force-re-resolve the changelog's ClickUp refs against the live API and upsert
 * the clickup_tasks cache. Works on any status (frozen changelogs are read from
 * jsonb; only the cache is refreshed). 503 when ClickUp is not configured.
 */
export const refreshReleaseTasks = defineEndpoint({
  method: 'POST',
  path: '/v1/releases/:releaseId/refresh-tasks',
  params: z.object({ releaseId: z.string().uuid() }),
  query: z.object({
    baseReleaseId: z.string().uuid().optional(),
    against: z.enum(['baseline', 'published']).default('baseline'),
  }),
  body: z.undefined(),
  response: z.object({ data: ChangelogSchema }),
});
